
import { useStore } from 'vuex'
import { ref, computed, onMounted } from 'vue'
import onTransitionendCallback from 'components/PageOverlay/methods/onTransitionendCallback'

// TinyMCE imports
import "tinymce/tinymce"
import "tinymce/themes/silver";
import "tinymce/icons/default";
import 'tinymce/models/dom/model'
import 'tinymce/skins/ui/oxide/skin.css';
// TinyMCE plugin imports
import 'tinymce/plugins/emoticons';
import 'tinymce/plugins/emoticons/js/emojis';
import 'tinymce/plugins/autoresize';
import 'tinymce/plugins/lists';
import 'tinymce/plugins/autolink';

import Editor from '@tinymce/tinymce-vue'

export default {
    name: "ClosedGroupOverlay",
    components: {
        Editor
    },
    props: {
        groupId: {
            type: String,
            required: true
        }
    },
    setup(props) {
        const store = useStore()
        let close
        const groupId = computed(() => props.groupId ?? store.state.main.page_overlay_content_data.groupId)
        const isFrivilligContext = computed(() => store.state.main.page_overlay_content_data.isFrivilligContext ?? false)

        const applicationContent = ref()
        const showInputErrors = ref(false)

        const isInputError = computed(() => !applicationContent.value?.length)
        const editorRef = ref(null)

        const getEditor = () => {
            if (typeof editorRef.value.getEditor !== "function") {
                console.error('Unable to get tinyMCE editor in ClosedGroupOverlay')
                return null
            }
            return editorRef.value.getEditor()
        }

        const tabTrap = function (e) {
            if (e.shiftKey && e.target.dataset.order === 'last') {
                e.preventDefault()
                if (getEditor()) {
                    getEditor().focus()
                }
            }

            if (!e.shiftKey && e.target.dataset.order === 'last') {
                e.preventDefault()
                close.focus()
            }

            if (!e.shiftKey && !e.target.dataset.order) {
                e.preventDefault()
                close.focus()
            }
        }
        
        const getLabel = (labelKey) =>
            store.getters["labels/getLabel"]({
                labelCollection: "ClosedGroupOverlay",
                labelKey: labelKey,
            });

        const submitMemberApplication = async function () {
            showInputErrors.value = true

            if (isInputError.value) return

            const body = {
                content: applicationContent.value,
            }

            if (isFrivilligContext.value) {
                await store.dispatch('frivillige/joinGroup', {
                    reason: body.content,
                    gruppeKode: groupId.value,
                })
            }
            else if (applicationContent.value) {
                store.dispatch('forum/submitMemberApplication', {
                    body: body,
                    id: groupId.value
                })
            }

            window.location.reload()
        }

        function editorInit() {
            return {
                plugins: 'emoticons autoresize lists autolink',
                toolbar: 'emoticons bold italic underline bullist numlist',
                toolbar_location: 'bottom',
                menubar: false,
                statusbar: false,
                license_key: 'gpl'
            }
        }

        onMounted(() => {
            close = document.querySelector('.kb-page-overlay__close')

            onTransitionendCallback({
                opening(){
                    close.focus()
                }
            }, { persistent: true })
        })

        return {
            tabTrap,
            editorRef,
            submitMemberApplication,
            applicationContent,
            isInputError,
            getEditor,
            showInputErrors,
            getLabel,
            editorInit
        }
    }
}